<template>
  <div class="autocomplete-container">
    <input type="text" v-model="searchText" :placeholder="placeholder" ref="searchInput" @focus="inputFocused=true" @blur="inputFocused=false" />
    <div class="results" :class="searchText || inputFocused ? 'active' : ''">
      <div v-for="item of availableOptions" :key="item.value" @mousedown="$emit('select', item.value); searchText = ''">
        {{item.label}}
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Autocomplete",
    props: ["options", "placeholder"],
    data() {
      return {
        searchText: "",
        inputFocused: false
      }
    },
    computed: {
      availableOptions() {
        return this.options.filter(el => this.searchText == "" || el.label.toUpperCase().indexOf(this.searchText.toUpperCase()) !== -1)
      }
    },
  }
</script>

<style scoped>
  .autocomplete-container {
    position: relative;
  }

  input {
    height: 100%;
    min-width: 620px;
    border: 1px solid #CCC;
    border-radius: 6px;
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
  }
  .results {
    display: none;
    position: absolute;
    top: 100%;
    left: 0;
    width: 600px;
    height: fit-content;
    max-height: 150px;
    overflow-y: scroll;
    background: white;
    z-index: 999999;

    border: 1px solid #CCC;
    border-radius: 6px;
    box-shadow: rgba(0, 0, 0, 0.4) 5px 5px 10px;
    padding: 4px 8px;
  }
  .results > * {
    padding: 6px 8px;
    border-bottom: 1px solid #CCC;
  }

  .results > *:hover {
    background-color: #E8E8E8;
    cursor: pointer;
  }

  .results.active {
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/Autocomplete.vue